import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  triggerApiUpdateComment,
  updateCommentInCartData,
} from '../actions/wishCompareCart';
import { updateCartItem, removeCartItem } from '../actions/cart';
import UIkit from 'uikit';
import demoImg1 from '../images/1tttt.jpg';
import deleteIcon from '../images/delete-icon.svg';
import Footer from './footer';
import { Link } from 'react-router-dom';
import i18n from 'i18next';
import loader from '../images/loader.svg';
import checkIcon from '../images/check-icon.svg';
import defImage from '../images/not-image.png';
import { config } from '../config';
import { Helmet } from 'react-helmet';

/**
 * Just a wrapper under list items
 *
 */
class CartList extends Component {
  static props = {
    cartData: PropTypes.object,
    isShowCompareCartWishLoader: PropTypes.boolean,
  };

  constructor(props) {
    super(props);
    this.state = { newCount: {} };
  }
  updateCartAction = (action, item) => {
    console.log('type of ', typeof item.count);
    if (action === 'remove' && item.count === 1) {
      UIkit.notification({
        message: this.props.t('cart.list_message_0_not_available'),
      });
    } else {
      this.props.updateAction(action, item);
    }
  };

  hadleUpdatecartItemCount(id, count) {
    this.setState({ newCount: { id: id, count: count } });
    this.props.cartData.data[id].count = count;

    this.updateCartAction('update', this.props.cartData.data[id]);
  }

  /**
   *
   *
   * @returns {*}
   */
  render() {
    const { t } = this.props;
    return (
      <div className='uk-container'>
        <header>
          <Helmet>
            <meta charSet='utf-8' />
            <title>{t('cart.cartname')}</title>
          </Helmet>
        </header>
        <div className='cart-block uk-margin-top'>
          <h1 className='page-title uk-text-bold'>{t('cart.cartname')}</h1>
        </div>
        {this.props.cartData.data !== undefined ? (
          <div className='cart-list'>
            <div
              className={
                this.props.isShowCompareCartWishLoader ? '' : 'uk-hidden'
              }
            >
              <div className='loader-overlay  uk-position-z-index'>
                <div className='uk-position-center'>
                  <img className='loader-img' alt={''} src={loader} uk-svg='' />
                </div>
              </div>
            </div>
            <table className='cart-table'>
              <thead
                className={
                  Object.keys(this.props.cartData.data).length == 0 &&
                  'uk-hidden'
                }
              >
                <tr>
                  <th>{t('cart._table_image')}</th>
                  <th>{t('cart._table_name')}</th>
                  <th>{t('cart._table_price')}</th>
                  <th>{t('cart._table_qty')}</th>
                  <th>{t('cart._table_storageUnitUa')}</th>
                  <th>{t('cart._table_total')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(this.props.cartData.data).length ? (
                  Object.keys(this.props.cartData.data).map((itm) => (
                    <tr className='cart-product'>
                      <td className='uk-text-center uk-padding-small'>
                        <img
                          alt={this.props.cartData.data[itm].productName}
                          className='cart-product__image'
                          src={
                            this.props.cartData.data[itm].mainImage
                              ? config.assetsPrfix +
                                'img/products/minB_' +
                                this.props.cartData.data[itm].mainImage
                              : defImage
                          }
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = defImage;
                          }}
                        />
                      </td>
                      <td>
                        <Link
                          className='cart-product__name '
                          to={
                            `/products/${
                              i18n.language +
                              '/' +
                              this.props.cartData.data[itm].alias
                            }` +
                            '/item/' +
                            this.props.cartData.data[itm].productId
                          }
                        >
                          {this.props.cartData.data[itm].productName}
                        </Link>
                      </td>
                      <td className='cart-product__price'>
                        <span className='cart-product__mob-text uk-hidden@m'>
                          {t('cart._table_price')}:
                        </span>{' '}
                        {this.props.cartData.data[itm].price}
                      </td>
                      <td className='cart-product__qty'>
                        <span className='cart-product__mob-text uk-hidden@m'>
                          {t('cart._table_qty')}:
                        </span>
                        <div className=' product-block__qty uk-position-relative'>
                          <span
                            className='product-block__qty-control  uk-position-center-left'
                            onClick={(e) =>
                              this.updateCartAction(
                                'remove',
                                this.props.cartData.data[itm]
                              )
                            }
                          >
                            -
                          </span>
                          <input
                            className='product-block__qty-inp uk-input uk-text-center'
                            type='text'
                            onChange={(e) => {
                              this.hadleUpdatecartItemCount(
                                itm,
                                e.target.value
                              );
                            }}
                            value={
                              this.state.newCount.id == itm
                                ? this.state.newCount.item_count
                                : this.props.cartData.data[itm].count
                            }
                            name='count'
                            // disabled={true}
                          />
                          <span
                            className='product-block__qty-control uk-position-center-right'
                            onClick={(e) =>
                              this.updateCartAction(
                                'add',
                                this.props.cartData.data[itm]
                              )
                            }
                          >
                            +
                          </span>
                        </div>
                      </td>
                      <td className='cart-product__price'>
                        <span className='cart-product__mob-text uk-hidden@m'>
                          {t('cart._table_storageUnitUa')}:
                        </span>{' '}
                        {this.props.cartData.data[itm].storageUnitUa}
                      </td>
                      <td className='cart-product__total'>
                        <span className='cart-product__mob-text uk-hidden@m'>
                          {t('cart._table_total')}:
                        </span>{' '}
                        {this.props.cartData.data[itm].priceTotal}
                      </td>
                      <td>
                        <div
                          className='cart-product__remove-btn uk-padding-small'
                          onClick={(e) =>
                            this.props.removeItem(
                              this.props.cartData.data[itm].productId,
                              this.props.cartData.data[itm].productName,
                              t('cart.msg_yes'),
                              t('cart.msg_no'),
                              t('cart.shure_remove')
                            )
                          }
                        >
                          <img alt={''} src={deleteIcon} uk-svg={''} />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <div>{t('cartlist.no_items')}</div>
                )}
              </tbody>
            </table>
            {Object.keys(this.props.cartData.data).length ? (
              <div className='cart-checkout-block uk-padding-small'>
                <div className='cart-checkout-block__total  uk-flex uk-flex-between'>
                  <span className='cart-checkout-block__total--text uk-text-bold'>
                    {t('cartlist.total_price')}:
                  </span>
                  <span className='cart-checkout-block__total--sum'>
                    {this.props.cartData.total} {this.props.cartData.currency}
                  </span>
                </div>
                <Link
                  to={'/products/' + i18n.language + '/cart/checkout'}
                  className={'cart-checkout-btn uk-button uk-margin-top'}
                >
                  {t('item.add_tocart')}
                </Link>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { cartData, isShowCompareCartWishLoader } = store.wishCompareCart;
  return {
    cartData,
    isShowCompareCartWishLoader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAction: (action, item) => {
      dispatch(updateCartItem(action, item));
    },
    removeItem: (item, itemName, msgYes, msgNo, msgShureRemove) => {
      UIkit.modal
        .confirm(
          '<p class="uk-text-emphasis">' +
            msgShureRemove +
            ` ${itemName}` +
            '</p>',
          { labels: { ok: msgYes, cancel: msgNo } }
        )
        .then(function () {
          dispatch(removeCartItem(item));
        });
    },
    changeComment: (e, itemId) => {
      dispatch(updateCommentInCartData(e.target.value, itemId));
    },
    saveCartComment: (id, uniqueId) => {
      dispatch(triggerApiUpdateComment(id, uniqueId));
    },
  };
};

const Cart = withTranslation('translations')(CartList);

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
